import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ItemCard from "../common/ItemCard";
import { useEmbedded } from "../../hooks/useEmbedded";

const MyLearningCard = ({ item, onItemAction, isEmbedded: isEmbeddedProp }) => {
  const navigate = useNavigate();
  const isEmbeddedFromHook = useEmbedded();
  const isEmbedded =
    isEmbeddedProp !== undefined ? isEmbeddedProp : isEmbeddedFromHook;

  const isCatlog = item.type === "course";
  const titleField = isCatlog ? "name" : "title";
  const imagePath = isCatlog ? "courses" : "learning_path";
  const pathPrefix = isEmbedded ? "/embed" : "";
  const viewPath = `${pathPrefix}${
    item.type === "course"
      ? `/learner/course/${item.id}`
      : `/learner/lpath/${item.id}`
  }`;

  const getButtonText = () => {
    if (item.progress === 100) return "Revisit";
    else if (item.progress === 0) return "Start";
    else if (item.progress > 0 && item.progress < 100) return "Continue";
    return "Start";
  };

  // Adapt the item structure to match what ItemCard expects
  const adaptedItem = {
    id: item.id,
    name: item.name,
    title: item.name, // Ensure both name and title are available
    description: item.description,
    cover_picture: item.cover_picture,
    bookmarked: item.bookmarked || item.isBookmarked,
    status: item.status || "3", // Assuming all items in My Learnings are published
    created_at: item.created_at,
    progress: item.progress || 0,
    learnerPath: viewPath,
    customButton: {
      text: getButtonText(),
      onClick: (e) => {
        e.stopPropagation();
        navigate(viewPath);
      }
    }
  };

  return (
    <ItemCard
      item={adaptedItem}
      onItemAction={onItemAction}
      itemType={
        item.type === 'course'
        ? 'course'
        : item.type === 'learning path'
        ? 'learningPath'
        : item.type === 'certificate'
        ? 'certificate'
        : 'job aid'
      }
      className="my-learning-card"
    />
  );
};

export default MyLearningCard;